export default "__VITE_ASSET__D4vc4y64__"